import React from 'react';
import video from '../../assets/preloader.mp4'
import './preloader.css'
import { useState } from 'react';
import { useEffect } from 'react';


const Preloader = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 2000);

    return () => clearTimeout(timer);
  }, [onFinish]);

    return ( 

        <section className="preloader">
            <video
            src={video}
            autoPlay
            muted
            playsInline
        />
        </section>
     );
}
 
export default Preloader;